import React, { useState, useRef } from 'react';

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

import Flow from './Flow';
import AutomationROI from './AutomationROI';
import ProcessRefinement from './ProcessRefinement';
import ProcessMgmt from './ProcessMgmt';
import ScreenFlow from './ScreenFlow';
import AppFlow from './AppFlow';

import ProcessList from './ProcessList';
import ProcessReport from './ProcessReport';
// import ProcessDesigner from './ProcessDesigner';
import ProcessDesignerFlow from './ProcessDesignerFlow';
import './dnd.css';
import VisualizeFlow from './VisualizeFlow';
import TaskMgmt from './TaskMgmt';
import Submissions from './Submissions';

import styled from 'styled-components';

const PDTabs = (props) => { 

const [model, setModel] = useState([])
const [tabIndex, setTabIndex] = useState(0);

const VerticalTabs = styled(Tabs)`
display: flex;
flex-direction:column;
justify-content: flex-end;
`
const VerticalTabList = styled(TabList)`
display: flex;
flex-direction:row;

`

return (
/* selectedTabClassName='select-tab'*/
<div className='proc' >
{/* <ProcessList refresh={props.refresh} setTabIndex={setTabIndex} onProcessIdChange = {props.onProcessIdChange}/> */}

<Tabs  style={{flexGrow:'20'}} selectedIndex={tabIndex}  onSelect={index => setTabIndex(index)} className="tabs" >
    <TabList >
      <Tab>Process Mgmt</Tab>
      <Tab>Process Designer</Tab>
      <Tab>Task Mgmt</Tab>
      {/* <Tab>Submit Task</Tab> */}
      <Tab>Submissions</Tab>
      {/* <Tab>Screen Flow</Tab> */}
      <Tab>Visualize Flow</Tab>
      {/* <Tab>Process Refinement</Tab> */}
      <Tab>Opportunity Analysis</Tab>

    </TabList>



    <TabPanel>
    <div className="panel-content">

      <ProcessMgmt title={"Processes"} setTabIndex ={setTabIndex} onProcessIdChange={props.onProcessIdChange} />
      </div>

    </TabPanel>
    <TabPanel>
      <ProcessDesignerFlow/>
    </TabPanel>

    <TabPanel>
    <div className="panel-content">

      <TaskMgmt title={"Tasks"} loading={props.loading} processId={props.processId} processName={props.processName}/>
      </div>

    </TabPanel>

    {/* <TabPanel> */}
      {/* <div align = 'center'>
      <h2>Activities Flow</h2>
      </div> */}

      {/* <VisualizeFlow title={"Main"} data={props.data} totalTime={props.totalTime } numScreens={props.numScreens}/> */}
      {/* <VisualizeFlow />
    </TabPanel> */}

    <TabPanel>
    <div className="panel-content">
      <Submissions loading={props.loading} processId={props.processId} processName={props.processName} setTabIndex ={setTabIndex} onSubmissionIdChange={props.onSubmissionIdChange}/>
    </div>
    </TabPanel>

    {/* <TabPanel>
      <ScreenFlow images={props.images}/>
    </TabPanel> */}
    
    
    <TabPanel>
    <div className="panel-content">
      <AppFlow processName={props.processName} loading={props.loading} data={props.apps} numScreens={props.numScreens} visdata={props.data} appSet={props.appSet} totalTime={props.totalTime } mostTimeSpent={props.mostTimeSpent} mostTimeSpentApp={props.mostTimeSpentApp} appHops={props.appHops} currentTaskName={props.currentTaskName}/>
      </div>
    </TabPanel>
    {/* <TabPanel>
        <ProcessRefinement/>
    </TabPanel> */}
    <TabPanel>
    <div className="panel-content">
      <ProcessReport loading={props.loading} processId = {props.processId} processName={props.processName}/>
      </div>
    </TabPanel>
  </Tabs>
  </div>

);
};
export default PDTabs;